function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Smart_home"
}, /*#__PURE__*/React.createElement("title", null, "VF_smart_home_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 123L141.7 48.4 0 123l13.2 25.2 15.1-7.7V234h226.8v-93.5l15.1 7.7 13.3-25.2zm-56.8 82.5H56.6v-80.1l85.1-44.9 85 44.9v80.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.7 151.4c11.7-4 24.2-6.1 37-6.1s25.2 2.1 37 6.1l14.3-24.9c-15.9-6.2-33.2-9.6-51.2-9.6-18.1 0-35.3 3.4-51.2 9.6l14.1 24.9zM111.9 164l14.5 25.5c4.9-1.1 10-1.7 15.2-1.7 5.2 0 10.3.6 15.2 1.7l14.5-25.5c-9.4-3-19.4-4.6-29.8-4.6-10.1 0-20.2 1.6-29.6 4.6z"
}))));